import React from "react";
const ModalButton = ({type, styleClass, toggle, target, controls, expanded, label, title,role,selected }) => {
    return (
        <button type={type} data-bs-toggle={toggle} data-bs-target={target} aria-controls={controls} role={role} aria-selected={selected} className={styleClass} aria-expanded={expanded} aria-label={label} >{title}</button>
    )
}
export default ModalButton;

